import { render, staticRenderFns } from "./WhatsappMsgChart.vue?vue&type=template&id=254d8d0e&"
import script from "./WhatsappMsgChart.vue?vue&type=script&lang=js&"
export * from "./WhatsappMsgChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports